import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[mesAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {
  private mesAutoFocus: boolean = true;

  constructor(private el: ElementRef) {
    if (!el.nativeElement['focus']) {
      throw new Error('Element does not accept focus.');
    }
  }

  @Input('mesAutoFocus')
  set _autosize(mesAutoFocus: boolean | string) {
    this.mesAutoFocus = typeof mesAutoFocus === 'boolean'
      ? mesAutoFocus
      : true;
  };

  ngAfterViewInit(): void {
    setTimeout(() => {
      const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
      if (input && this.mesAutoFocus) {
        input.focus && input.focus();
        if (!input.getAttribute('mesVirtualKeyboard')) {
          input.select && input.select();
        }
      }
    }, 50);
  }
}
